import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
    }

    save() {
        this.close({$value: this.st.selectedIds});
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/choose-folder/choose-shared-folder.controller.js